import React from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Text, Input } from "react_reusable_components";
import {
  DownloadOutlined,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";

import Button from "../../components/Button";
import useResponsive from "../../core/hooks/useResponsive";
import ListingHeaderLayout from "../../layouts/ListingHeaderLayout";
import ThreeColumn from "../../core/layouts/ThreeColumn";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import Styles from "./productCategoryListingTopContainer.module.scss";

const ProductCategoryListingTopContainer = ({
  query,
  setQuery,
  isAdmin,
  downloadProductCategoryReportsHandler,
}) => {
  const intl = useIntl();
  const responsive = useResponsive();
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setQuery((prevQuery) => ({
      ...prevQuery,
      searchStr: e.target.value,
    }));
  };

  return (
    <ListingHeaderLayout
      firstSection={
        <Text className={Styles["heading-text"]}>
          {getLocalizedMessage(intl, "productCategory.listingHeading")}
        </Text>
      }
      secondSection={
        <ThreeColumn
          className={Styles["second-section-style"]}
          leftSectionStyle={{ flex: 1 }}
          leftSection={
            <Input
              className={`${Styles["input-style"]} ${
                Styles[!responsive?.isMd && "input-style-mobile"]
              }`}
              placeholder={getLocalizedMessage(
                intl,
                "productCategory.searchPlaceholder"
              )}
              prefix={
                <SearchOutlined className={Styles["search-icon-style"]} />
              }
              value={query.searchStr}
              onChange={handleInputChange}
            />
          }
          middleSection={
            <Button
              icon={<DownloadOutlined className={Styles["plus-icon-style"]} />}
              className={`${Styles["generate-report"]} ${
                !isAdmin && Styles["generate-report-ca"]
              }`}
              type="text"
              onClick={downloadProductCategoryReportsHandler}
            >
              {responsive.isSm &&
                getLocalizedMessage(intl, "button.generateReport")}
            </Button>
          }
          rightSection={
            isAdmin && (
              <Button
                icon={
                  <PlusOutlined
                    className={`${Styles["plus-icon-style"]}  ${
                      !isAdmin && Styles["plus-icon-mobile"]
                    }`}
                  />
                }
                className={Styles["add-button"]}
                onClick={() => navigate("/add-product-category")}
              >
                {responsive.isSm &&
                  getLocalizedMessage(
                    intl,
                    "productCategory.addNewProductCategory"
                  )}
              </Button>
            )
          }
        />
      }
    />
  );
};

export default ProductCategoryListingTopContainer;
